import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SvgIcon from '@material-ui/core/SvgIcon';
import FileIcon from '../FileIcon';
import { getExtension } from '../../utils';

@inject('authStore')
@observer
export default class Attachment extends Component {
  extension;
  url;

  constructor(props) {
    super(props);

    const { authStore, attachment } = this.props;

    this.extension = getExtension(attachment.FILENAME);

    this.url = authStore.getAttachmentURL(attachment, this.props.type);
    
    authStore.refreshExpiringToken();
  }

  
  onSelect = () => {

    const { authStore, attachment } = this.props;

    this.url = authStore.getAttachmentURL(attachment, this.props.type);

    // If attachment is [jpg] or [png] use the [onAttachmentSelected] passed as a prop from [Attachments] to show it in [LightBox]
    if (this.extension === 'jpg' || this.extension === 'png') {
        this.props.onAttachmentSelected(this.url);
    }
    else{
     
     var link = document.createElement('a');
     link.href = this.url;
     link.target = "_blank";
     link.rel = "noreferrer noopener";
     link.click();
     
    }
    
  }

  render() {
    return (
      <div>
          <div className="margin-sm" style={{ color: '#666', border: '4px solid #666', borderRadius: 8, width: 50, height: 50, cursor: 'pointer' }} onClick={this.onSelect}>
            <SvgIcon style={{ width: '100%', height: '100%' }} >
              <FileIcon extension={this.extension} />
            </SvgIcon>
          </div>

      </div>

    );
  }
}
